import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    key = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.getValue, { key }, options);
    if (error) return { error, status };
    return content || { value: '' };
};
